import { CSSProperties } from '@harmony/enablers/react/scope-for-react';

export const commonGridStyle = {
  height: 'auto',
  width: '100%',
  maxWidth: '100%',
};

export const smallPanelStyle = {
  '--size': 'var(--he-panel-size-small)',
  zIndex: 3,
};

export const mediumPanelStyle = {
  '--size': 'var(--he-panel-size-medium)',
  zIndex: 3,
};

export const largePanelStyle = {
  '--width': '75rem',
  '--size': 'var(--he-panel-size-large)',
  zIndex: 2,
};

export const longComboBoxStyle = {
  width: '348px',
  maxWidth: '100%',
  zIndex: 3,
};

export const extraLongComboBoxStyle = {
  width: '400px',
  maxWidth: '100%',
  zIndex: 3,
};

// KPI cards style
export const cardStyleA = {
  display: 'flex',
  width: '399px',
  height: '600px',
  alignItems: 'stretch',
};

// Performance Page middle card style
export const cardStyleB = {
  display: 'flex',
  width: '610px',
  minHeight: '510px',
  gap: '20px',
  alignItems: 'stretch',
};

// Earnings Page middle card style
export const cardStyleC = {
  display: 'flex',
  width: '610px',
  maxWidth: '610px',
  minHeight: '410px',
  alignItems: 'stretch',
  gap: '20px',
};

// App body style
export const bodyContentStyles = {
  padding: '1.5rem 1.5rem 0 1.5rem',
};

// App Command Bar style
export const titleCommandBarStyles = {
  display: 'flex',
  paddingBottom: '1rem',
  gap: 'var(--he-spacing-large)',
};

// Search Box for DataGrids style
export const searchBoxStyle: CSSProperties = {
  maxWidth: '160px',
  marginLeft: 'auto',
  flexDirection: 'row',
};

export const blockSpacing = {
  marginBottom: '40px',
};
export const subBlockSpacing = {
  marginBottom: '32px',
};

// Attainment Card container style (shared)
export const attainmentCardStyle = {
  display: 'flex',
  gap: '20px',
  flexWrap: 'wrap' as const,
  width: 'fit-content',
};
